export default __webpack_public_path__ + "static/media/13_Call-an-old-friend_Share.d737d0e9.jpg";